export enum PaymentMethodType {
    OnAccount = 0,
    PayOnline = 1
}